import { Component, Input, OnInit } from '@angular/core';
import { HomeworkLink } from '../../../../../models/homework-link';
import { HomeworkService } from '../../../../../services/homework.service';
import { AssetService } from '../../../../../services/asset.service';
import { CommunicationService } from '../../../../../services/communication.service';
import { ModalService } from '../../../../../services/modal.service';
import { ApplicationStateService } from '../../../../../services/application-state.service';

@Component({
    selector: 'sidebar-homework-item',
    templateUrl: './homework-item.component.html',
    styleUrls: ['./homework-item.component.scss'],
    standalone: true
})
export class HomeworkItemComponent implements OnInit {

    @Input() homework: HomeworkLink;
    @Input() foreign?: boolean;

    opened = false;
    title;
    downloadLink: string;
    link: string;

    constructor(public assetService: AssetService,
                public communicationService: CommunicationService,
                public applicationStateService: ApplicationStateService,
                public homeworkService: HomeworkService,
                private modalService: ModalService) {
    }

    ngOnInit(): void {
        this.title = this.getTitle();
        // @ts-ignore
        this.downloadLink = this.homeworkService.getEvaluationLink(this.homework);
        this.link = this.homework.getLink();
    }

    /**
     * is user a teacher
     *
     * @returns {boolean}
     */
    isTeacher(): boolean {
        return this.homeworkService.isTeacher();
    }

    /**
     * should delivery counter be shown
     */

    /*showDelivery(): boolean {
        return this.isTeacher() && this.homework.deliveryCounter != null;
    }*/

    /**
     * calculate days until dueDate
     *
     * @param {Date} dueDate
     * @returns {number}
     */
    calcDays(dueDate: Date): number {
        if (!dueDate) {
            return null;
        }

        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
        const dayDif = (dueDate.getTime() - today.getTime());

        return Math.ceil(dayDif / 1000 / 60 / 60 / 24);
    }

    /**
     * event handler for working on homework
     *
     * @param {HomeworkLink} homework
     */
    workOnHomework(homework: HomeworkLink): void {
        return;
    }

    /**
     * event handler to change homework
     *
     * @param {HomeworkLink} hw
     */
    copyHomework(hw: HomeworkLink): void {
        const newHomework = new HomeworkLink();
        newHomework.exercises = hw.exercises;
        newHomework.title = hw.title;
        newHomework.email = hw.email;
        newHomework.cooldownPhase = hw.cooldownPhase;
        this.homeworkService.syncHomework(newHomework);
        this.communicationService.announceAddHomework();
    }

    /**
     * event handler to show link
     *
     * @param {HomeworkLink} homework
     */
    showLink(homework: HomeworkLink): void {
        this.homeworkService.openHomework();
        this.opened = true;
        homework.bypassCheck = true;
        this.modalService.openModal(this.homework);
    }

    /**
     * event handler for opening correction side
     *
     * @param {HomeworkLink} homework
     */
    openCorrection(homework: HomeworkLink): void {
        window.location.href = homework.correctionLink;
    }

    /**
     * event handler for downloading results
     *
     * @param {HomeworkLink} homework
     */
    downloadResults(homework: HomeworkLink): void {
        window.location.href = homework.downloadLink;
    }

    /**
     * event handler for clicking on whole homework
     *
     * @param {HomeworkLink} homework
     */
    clickHomework(homework: HomeworkLink): void {
        this.showLink(homework);
        // if (this.isTeacher()) {
        //     this.showLink(homework);
        // } else {
        //     this.workOnHomework(homework);
        // }
    }

    /**
     * is homework modal opened
     *
     * @returns {boolean}
     */
    isModalOpen(): boolean {
        if (!this.homeworkService.isHomeworkOpened()) {
            this.opened = false;
        }

        return this.opened;
    }

    toggleSelectedForDeletion(): void {
        this.homework.selectedForDeletion = !this.homework.selectedForDeletion;
    }

    /**
     * get title of homework
     *
     * @return {string}
     */
    getTitle(): string {
        return this.homework.title || `${this.homework.domain}/${this.homework.link}`;
    }

    protected deleteHomework(homework: HomeworkLink) {
        if (!homework.id) {
            this.homeworkService.homeworks[0] = this.homeworkService.homeworks[0].filter(elem => elem !== homework);
        } else {
            this.homeworkService.removeHomework(homework)
                .then(() => {
                    this.homeworkService.homeworks[0] = this.homeworkService.homeworks[0].filter(elem => elem !== homework);
                })
                .catch(() => {
                    return;
                })
            this.communicationService.announceHomeworkRemove();
        }
    }
}
